import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment as env } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { User, Application, UserObject, UserGroup } from '../models/Datatype';
import notify from 'devextreme/ui/notify';

@Injectable()
export class AuthService {
  isLoggedIn: boolean = false;
  isSidebarVisible: boolean = true;
  isSidebarOpened: boolean = true;
  minSidebarSize = 60;
  isTopbarVisible: boolean = true;
  redirectUrl: string = '';
  user: User = new User();
  menus: any[] = [];
  showChart: boolean = true;
  plant: string = "%";
  currentApp: Application;

  constructor(private router: Router, private http: HttpClient) {
    this.loadSession();
    this.logout = this.logout.bind(this);
  }

  getOauth() {
    return new Promise((resolve,reject) => {
      let oauth = this.getCookie('oauth');

      if (oauth == undefined) {
        let refresh = this.getCookie('refresh_token');

        if (refresh == undefined) {
          resolve(undefined);
        } else {
          let clientId = env["clientId"];
          let clientSecret = env["clientSecret"];
          let body = "clientId=" + clientId +
            "&clientSecret=" + clientSecret +
            "&refresh_token=" + refresh +
            "&grant_type=refresh_token";
          let headers = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded',
          });

          this.http.post("https://oauth2.googleapis.com/token", body, { headers: headers }).toPromise().then(res => {
            oauth = res["access_token"];
            this.setCookie("oauth", oauth, 50);
            resolve(oauth);
          }).catch(error => {
            resolve(undefined);
          });
        }
      } else {
        resolve(oauth);
      }
    });
  }

  setCookie(name: string, value: string, minute: number, path: string = '/') {
    let d: Date = new Date();
    d.setTime(d.getTime() + minute * 60 * 1000);
    let expires: string = `expires=${d.toUTCString()}`;
    let cpath: string = path ? `; path=${path}` : '';
    document.cookie = `${name}=${value}; ${expires}${cpath}`;
  }

  deleteCookie(name) {
    this.setCookie(name, '', -1)
  }

  clearCookies() {
    let cookie = this.getListCookies();
    if (cookie) {
      Object.keys(cookie).forEach((key) => {
        this.deleteCookie(key);
      });
    }
  }

  getConfigSession(value) {
    let data = JSON.parse(sessionStorage.getItem('config'));
    return data[value];
  }

  getCookie(item): any {
    return this.getListCookies()[item];
  }

  getListCookies(): any {
    return document.cookie.split(';').reduce((cookies, cookie) => {
      const [name, value] = cookie.split('=').map(c => c.trim());
      cookies[name] = value;
      return cookies;
    }, {});
  }

  getObjectFilter(field, objc) {
    let usedObjects: UserObject[] = this.user.userObjects[env["currentApp"]] != undefined ? this.user.userObjects[env["currentApp"]][objc] : undefined;

    //Try to use userObjects first then authObjects
    if (usedObjects == undefined || usedObjects.length == 0) {
      usedObjects = this.user.authObjects[env["currentApp"]] != undefined ? this.user.authObjects[env["currentApp"]][objc] : undefined;
    }
    if (usedObjects == undefined || usedObjects.length == 0) return " AND 1=2 ";

    let filter = " AND (";
    let operator = "";

    usedObjects.forEach(obj => {
      if (obj.val1.indexOf("%") >= 0) operator = "LIKE"; else operator = "=";

      filter += field + " " + operator + " '" + obj.val1 + "' OR ";
    });

    filter = filter.substring(0, filter.length - 3);
    filter += ") ";

    return filter;
  }

  loadPlant() {
    if (this.user.userObjects["wings-hds"] != undefined) {
      if (this.user.userObjects["wings-hds"]["plant"] != undefined) {
        this.plant = this.user.userObjects["wings-hds"]["plant"][0]["val1"].toString();
      } else {
        this.plant = "%";
      }
    } else {
      this.plant = "%";
    }
  }

  public permission(type,url?){
    let isExist = false;
    url = url == undefined ? this.router.url : url;
    let currentUrl = this.getCleanUrl(url);
    let menuContent = this.user.menus.find(x => x["menuUrl"]==currentUrl);
    if(menuContent!=undefined){
      isExist = menuContent.action.includes(type);
    }
    return isExist;
  }

  private getCleanUrl(str:string){
    let arrUrl = str.split(';');
    let url = arrUrl[0];
    url = url.split('/').join('');
    return url;
  }

  loginByEmail(acces_token){
    return new Promise((resolve,reject)=>{
      this.post("public/login/token-info", { access_token: acces_token },false).then(res => {

        return this.post("public/login/login-by-email", { email: res[0]["email"] },false);
      }).then(rows => {
        if (rows['token'] != undefined && rows['token'] != null) {
          this.setCookie('token', rows['token'], 1440);
          this.isLoggedIn = true;
          this.user = <User>rows["user"];
        }
        return this.get(`msuser/${this.user.userName}/group-list`,false);
      }).then(rows => {
        this.user.groups = <UserGroup[]>rows;

        return this.get(`msuser/${this.user.userName}/app-list`,false);
      }).then(rows => {
        this.user.apps = <Application[]><unknown>rows;
        this.user.apps.forEach(app => {
          app.appUrl = app.appUrl;
        });
        this.saveSession();

        resolve(true);
      }).catch(err => {
        reject(err);
      });
    })
  }

  post(url: string, body: any,showError:boolean=true) {
    return new Promise((resolve, reject) => {
     var headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getCookie('token')}`
      });
      this.http.post(env["apiUrl"] + url, body, { headers: headers, withCredentials: true }).toPromise()
      .then(result => {
        if (result["result"]) {
          resolve(result["rows"]);
        } else {
          this.errorHandler(result,showError);
          reject(result);
        }
      })
      .catch(result => {
        this.errorHandler(result,showError);
        reject(result);
      });
    });
  }

  get(url,showError:boolean=true){
    return new Promise((resolve, reject) => {
      var headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getCookie('token')}`
      });
      this.http.get(env["apiUrl"] + url, { headers: headers, withCredentials: true }).toPromise()
      .then(result => {
        if (result["result"]) {
          resolve(result["rows"]);
        } else {
          this.errorHandler(result,showError);
          reject(result);
        }
      })
      .catch(result => {
        this.errorHandler(result,showError);
        reject(result);
      });
    });
  }

  errorHandler(result:any,showError:boolean=true) {
    let errMsg = "";
    console.log(result.status);
    if (result.status == 401) {
      this.goToLoginPage();
    }else if (result.message != undefined) {
      errMsg = result.message;
    } else if (result.error instanceof ErrorEvent) {
      errMsg = 'An error occurred:', result.error.message;
    } else {
      errMsg = `Backend returned code ${result.status}, ` + `body was: ${result.error}`;
    }

    if(showError){
      this.showErrorDialog(errMsg);
    }
  }

  showErrorDialog(message: string) {
    let option = {
      closeOnClick: true,
      message: message
    };

    notify(option, 'error', 10000);
    /*this.confirmClass = 'orchestra-error';
    this.confirmation.confirm({
        header: 'Error',
        message: message,
        icon: 'fa fa-warning',
        accept: () => {}
    });*/
  }

  goToLoginPage() {
    localStorage.clear();
    sessionStorage.clear();
    this.clearCookies();
    this.router.navigate(['/login']);
  }

  loginWithGoogle(code) {
    return new Promise((resolve, reject) => {
      let clientId = env["clientId"];
      let clientSecret = env["clientSecret"];
      let redirect = env["loginUrl"] + "/google-login";
      let body = "clientId=" + clientId +
        "&clientSecret=" + clientSecret +
        "&code=" + code +
        "&redirect_uri=" + redirect +
        "&grant_type=authorization_code";
      var headers = new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      });
      this.http.post("https://oauth2.googleapis.com/token", body, { headers: headers })
        .toPromise().then(res => {
          this.setCookie("oauth", res["access_token"], 50);
          this.setCookie("refresh_token", res["refresh_token"], 1440);
          resolve(true);
        }).catch(err => {
          reject(false);
        });
    })
  }

  setRedirectUrl(){
    this.redirectUrl = this.router.url;
    localStorage.setItem('auth.redirectUrl', this.redirectUrl);
  }

  goToRedirect(){
    let url = localStorage.getItem("auth.redirectUrl");
    this.redirectUrl = "/";
    localStorage.setItem('auth.redirectUrl', this.redirectUrl);
    this.router.navigateByUrl(this.redirectUrl);
  }

  login(userName: string, password: string) {
    return new Promise((resolve, reject) => {

      this.post('public/login', {
        userName: userName,
        password: password
      },false)
      .then(rows => {
        if (rows['token'] != undefined && rows['token'] != null) {
          this.setCookie('token', rows['token'], 1440);
          this.isLoggedIn = true;
        }

        return this.get(`msuser/detail/${userName}`,false);
      })
      .then(rows => {
        this.user = <User>rows[0];

        return this.get(`msuser/${this.user.userName}/group-list`,false);
      })
      .then(rows => {
        this.user.groups = <UserGroup[]>rows;

        return this.get(`msuser/${this.user.userName}/app-list`,false);
      })
      .then(rows => {
        this.user.apps = <Application[]>rows;
        this.user.apps.forEach(app => {
          app.appUrl = app.appUrl;
        });
        this.saveSession();

        resolve(true);
      }).catch(err => {
        this.errorHandler(err,false);
        reject(err);
      });
    });
  }

  logout() {
    this.user = null;
    this.isLoggedIn = false;
    this.isSidebarVisible = false;
    this.redirectUrl = "/";
    this.currentApp = null;
    this.menus = [];
    localStorage.clear();
    sessionStorage.clear();
    this.clearCookies();
    this.router.navigate(["/login"]);
  }

  saveSession() {
    return new Promise((resolve)=>{
      localStorage.clear();
      localStorage.setItem('auth.user', JSON.stringify(this.user));
      localStorage.setItem('auth.isLoggedIn', String(this.isLoggedIn));
      localStorage.setItem('auth.isSidebarVisible', String(this.isSidebarVisible));
      localStorage.setItem('auth.redirectUrl', this.redirectUrl);
      localStorage.setItem('auth.currentAppUrl', env["currentAppUrl"]);
      localStorage.setItem('auth.currentApp', JSON.stringify(this.currentApp));
      localStorage.setItem('auth.menus', JSON.stringify(this.menus));
      resolve(true);
    });
  }

  getServer(){
    let svr = JSON.parse(sessionStorage.getItem('config'))["appServer"];
    return svr!=undefined? svr:"";
  }

  loadSession() {
    if (localStorage.getItem('auth.user') != 'undefined') this.user = JSON.parse(localStorage.getItem('auth.user'));
    if (localStorage.getItem('auth.isLoggedIn') != 'undefined') this.isLoggedIn = Boolean(localStorage.getItem('auth.isLoggedIn'));
    if (localStorage.getItem('auth.isSidebarVisible') != 'undefined') this.isSidebarVisible = Boolean(localStorage.getItem('auth.isSidebarVisible'));
    if (localStorage.getItem('auth.redirectUrl') != 'undefined') this.redirectUrl = localStorage.getItem('auth.redirectUrl');
    if (localStorage.getItem('auth.currentApp') != 'undefined') this.currentApp = JSON.parse(localStorage.getItem('auth.currentApp'));
    if (localStorage.getItem('auth.menus') != 'undefined') this.menus = JSON.parse(localStorage.getItem('auth.menus'));
  }

  onSidebarClick(data) {
    if (data.itemData.url != null) {
      this.router.navigateByUrl(data.itemData.url);
      this.isSidebarOpened = false;
    }
  }

  isInGroup(group) {
    let index = this.user.groups.findIndex(x => x.groupCode == group);
    return index >= 0 ? true : false;
  }
}
